<template>
  <div>
    <template v-if="isLoading">
      <Loading/>
    </template>
    <template v-else-if="hasDbError">
      <Error 
        v-for="(error,key) in dbErrors"
        v-if="error" 
        :key="key"
        error="error"/>
    </template>
    <template v-else-if="!isClubAdmin">
      <Error :error="$t('general.errors.needToBeAdmin')"/>
    </template>
    <template v-else>
      <BaseTable
        :page="page" 
        :entity="entity"
        :items="clubUsers"
        :model="model"
        :allow-go="false" 
        :allow-add="true" 
        :allow-edit="true" 
        :allow-delete="isClubAdmin" 
        :admin-mode="isClubAdmin"
        @onAdd="onAdd"
        @onUpdate="onUpdate"
        @onDelete="onDelete"
        @onGo="onGo">
        <template 
          slot="card" 
          slot-scope="{item, adminMode}"> 
          <ClubUserCard 
            :item="user(item)"
            :admin-mode="adminMode"
            @onUpdate="onUpdate"
            @onDelete="onDelete" />
        </template>
        <template 
          slot="email" 
          slot-scope="{item}">
          {{ userText(item) }}
        </template>
        <template 
          v-if="currentUser && item.id === currentUser.uid"
          slot="deleteButton"
          slot-scope="{item}" >
          <v-btn  
            :disabled="true"
            flat>
            <v-icon>delete_forever</v-icon>
          </v-btn>
        </template>
      </BaseTable>
    </template>
    <v-snackbar
      v-if="snackbarOpen"
      v-model="snackbarOpen"
      :timeout="timeout"
      top >
      {{ $t(`general.errors.${formError}`) }}
      <v-btn
        flat 
        color="pink"
        @click.native="hideSnackbar">{{ $t('general.close') }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash'
import BaseTable from '@/components/Base/BaseTable'
import ClubUserCard from '@/components/Dashboard/Views/Club/Views/ClubUsers/Templates/ClubUserCard'
import ClubUsersLib from '@/lib/data/clubUsers'
import ClubsLib from '@/lib/data/clubs'
import UsersLib from '@/lib/data/users'
import clubUserModel from '@/lib/data/models/clubUser'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import SecurityHelper from '@/lib/SecurityHelper'
const debug = require('debug')('OD::ClubUsers')

export default {
  name: 'ClubUsers',
  components: {
    BaseTable,
    ClubUserCard,
    Loading,
    Error,
  },
  mixins: [BaseMixin],
  props: {
    clubId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      page: 'clubUsers',
      entity: 'clubUser',
      formError: '',
      club: {},
      clubUsers: [],
      users: [],
      loadings: {
        clubUsers: true,
        users: true,
        club: true,
      },
      dbErrors: {
        clubUsers: null,
        users: null,
        club: null,
      },
      snackbarOpen: false,
      timeout: 4000,
    }
  },
  computed: {
    model() {
      return clubUserModel
    },
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    isClubAdmin() {
      return SecurityHelper.isClubAdmin(this.currentUser, this.clubUsers, this.clubId)
    },
  },
  watch: {
    currentUser() {
      this.bind()
    },
    formError() {
      if (this.formError) {
        this.snackbarOpen = true
      }
    },
    club() {
      if (this.club) {
        this.$emit('updateHead')
      }
    },
  },
  created() {},
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubUsersLib.bindAll(this, { clubId: this.clubId })
      ClubsLib.bindItem(this, { clubId: this.clubId })
      UsersLib.bindAll(this)
    },
    user(clubUser) {
      const user = this.users.find(item => item.id === clubUser.id)
      if (user) {
        return Object.assign(clubUser, user)
      }
      return null
    },
    userText(clubUser) {
      const user = this.users.find(item => item.id === clubUser.id)
      if (user) {
        const name = user.customName
          ? ` [${user.customName}]`
          : user.displayName
            ? ` [${user.displayName}]`
            : ''
        return user.email + name
      }
      return '---'
    },
    onAdd(newItem) {
      debug('onAdd', newItem)
      this.formError = ClubUsersLib.add(this, this.currentUser, newItem, { clubId: this.clubId })
      debug('onAdd', { result: this.formError })
      if (this.formError) {
        this.snackbarOpen = true
      }
    },
    onUpdate(newItem, item) {
      debug('onUpdate', newItem, item)
      ClubUsersLib.update(this, this.currentUser, newItem, item)
    },
    onGo(item) {
      debug('onGo', item)
    },
    onDelete(item) {
      debug('onDelete', item)
      ClubUsersLib.delete(this, this.currentUser, item, { clubId: this.clubId })
    },
    hideSnackbar() {
      this.snackbarOpen = false
      this.formError = ''
    },
  },
  head: {
    title: function() {
      const club = this.club && this.club.club ? this.club.club : ''
      return {
        inner: `${club || ''} | ${this.$t('page.clubUsers.title')}`,
      }
    },
  },
}
</script>

<style>
</style>
